import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-20 md:py-32" data-id="element-147">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="bg-white rounded-2xl shadow-xl border border-teal/5 overflow-hidden" data-id="element-150">
            <div className="bg-teal p-8 text-center" data-id="element-151">
              <h2 className="font-serif text-2xl md:text-3xl text-cream mb-2" data-id="element-152">
                Recuperá tu ligereza hoy mismo
              </h2>
              <p className="text-cream/80 font-light" data-id="element-153">
                El acceso completo al Protocolo Anti-Inflamatorio 40+ tiene un
                valor único promocional de lanzamiento.
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-154">
              <div className="mb-8" data-id="element-155">
                <span className="text-teal/60 font-light uppercase tracking-wider text-sm block mb-3" data-id="element-156">
                  Oferta de lanzamiento
                </span>

                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-157">
                  <span className="font-serif text-2xl text-teal/40 line-through decoration-gold/60 decoration-[1.5px]" data-id="element-158">
                    $19.99
                  </span>
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-gold/15 text-gold text-xs font-semibold tracking-wider uppercase" data-id="element-159">
                    -68% OFF
                  </span>
                </div>

                <div className="flex items-baseline justify-center gap-2" data-id="element-160">
                  <span className="font-serif text-5xl md:text-6xl text-teal" data-id="element-161">
                    $6.39
                  </span>
                  <span className="text-xl text-teal/70" data-id="element-162">USD</span>
                </div>

                <p className="text-teal/50 text-sm mt-3 font-light" data-id="element-163">
                  (o su equivalente en ARS al cambio del día)
                </p>
              </div>

              <Button href="https://www.nuevoeje.com/cart/55123453673763:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto md:px-12 py-5 text-lg mb-6" data-id="element-164">
                ¡Sí, quiero empezar mi reset!
              </Button>

              <div className="flex flex-col items-center gap-3 text-sm text-teal/60 font-light" data-id="element-165">
                <div className="flex items-center gap-2" data-id="element-166">
                  <Lock size={16} className="text-gold" data-id="element-167" />
                  <span data-id="element-168">Pago 100% seguro y encriptado</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-169">
                  <ShieldCheck size={16} className="text-gold" data-id="element-170" />
                  <span data-id="element-171">Acceso inmediato a través de Hotmart</span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}